import { msg } from '@lingui/core/macro';

export const SHARED_CONSENT_AGREEMENT_MODAL_CONSENT_CENTER = msg`Consent Center`;
export const SHARED_CONSENT_AGREEMENT_MODAL_SELECT_ALL = msg`Select All`;
export const SHARED_CONSENT_AGREEMENT_MODAL_CONSENT_UPDATE_REQUIRED = msg`Consent Update Required`;
export const SHARED_CONSENT_AGREEMENT_MODAL_DESELECT_ALL = msg`Deselect All`;
export const SHARED_CONSENT_AGREEMENT_MODAL_CANCEL = msg`Cancel`;
